import {
  TENANT_NOTES_LOAD_REQUEST,
  TENANT_NOTES_LOAD_SUCCESS,
  TENANT_NOTES_LOAD_FAILURE,
  TENANT_NOTE_EDIT_START,
  TENANT_NOTE_EDIT_CANCEL,
  TENANT_NOTE_CREATE_SUCCESS,
} from '../actions/tenantNote';

const initialState = {
  notes: [],
  loaded: false,
  editing: false,
};

function initializeState(){
  return Object.assign({}, initialState);
}

export default function tenantNotes(state = initializeState(), action = {}) {
  switch (action.type) {
    case TENANT_NOTES_LOAD_REQUEST:
      return {
        ...state,
        loading: true
      };
    case TENANT_NOTES_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        notes: action.notes,
        error: null
      };
    case TENANT_NOTES_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        notes: null,
        error: action.error
      };

    case TENANT_NOTE_EDIT_START:
      return {
        ...state,
        editing: true
      };
    case TENANT_NOTE_EDIT_CANCEL:
      return {
        ...state,
        editing: false
      };

    case TENANT_NOTE_CREATE_SUCCESS:
      let notes = [...state.notes];
      return {
        ...state,
        notes: [action.note, ...notes],
        editing: false,
      };

    default:
      return state;
  }
}
